module.exports = __webpack_public_path__ + "img/e-class-cabriolet.811328ea.jpg";